import { catalog, unwrap } from "../api";
import type { TierOption } from "../../components/customers/assign-terms-form";

/**
 * Catalog's tiers, for the assign-terms form and the default tier a demotion names. Kept local to
 * the customers feature (not shared with the catalogue feature's own tier list) — the original
 * Next pages (customers/[id]/page.tsx, customers/trade-terms/page.tsx) each had their own local
 * `tierOptions()` doing exactly this rather than importing across features, so this mirrors that.
 *
 * A failed read returns an empty list rather than throwing: the tier list is what the *forms*
 * need, and losing the whole customer record because Catalog is unreachable would hide the terms,
 * balance and ledger status the page exists to show.
 */
export async function listActiveTiers(): Promise<TierOption[]> {
  try {
    const data = (await unwrap(
      (await catalog()).GET("/api/catalog/tiers", { params: { query: { activeOnly: true, page: 1, pageSize: 200 } } }),
    )) as { items: { id: string; name: string; isDefault: boolean; isActive: boolean }[] } | undefined;
    return (data?.items ?? []).map((tier) => ({ id: tier.id, name: tier.name, isDefault: tier.isDefault, isActive: tier.isActive }));
  } catch {
    return [];
  }
}
